import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GenericService {

  baseUrl = environment.baseUrl;
  constructor(private http:HttpClient) { }

  public Get<T>(url:string):Observable<T>{
    return this.http.get<T>(this.baseUrl+url);
  }

  public Post<T>(url:string, data:any):Observable<T>{
    return this.http.post<T>(this.baseUrl+url, data);
  }
  public Delete<T>(url:string):Observable<T>{
    return this.http.delete<T>(this.baseUrl+url);
  }
}
